import { BroadbandProvider } from "fond/types/broadbandProvider";
import { BBox } from "fond/types/geometry";

import { apiSlice } from "./apiSlice";

interface GetBroadbandProvidersParams {
  accountId: string;
  bounds?: BBox | null;
  serviceType?: "fiber" | null;
}

interface GetBroadbandProvidersResponse {
  BroadbandProviders: BroadbandProvider[];
}

export const broadbandProviderSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBroadbandProviders: build.query<BroadbandProvider[], GetBroadbandProvidersParams>({
      query: ({ accountId, bounds, serviceType }) => ({
        url: "/v2/broadband-providers",
        params: {
          account_id: accountId,
          ...(bounds
            ? {
                min_x: bounds[0][0],
                min_y: bounds[0][1],
                max_x: bounds[1][0],
                max_y: bounds[1][1],
              }
            : {}),
          ...(serviceType ? { service_type: serviceType } : {}),
        },
      }),
      transformResponse: (response: GetBroadbandProvidersResponse) => response.BroadbandProviders,
    }),
  }),
});

export const { useGetBroadbandProvidersQuery } = broadbandProviderSlice;
